import Router from 'next/router';

import { Button, Box, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import config from 'src/config';

import CpdCardBoxStyle from './style';

import Image from '@components/atoms/image';

type Props = {
  imagePathName?: string;
  imageAlt?: string;
  topic?: string;
  subTopic?: string;
  descriptions?: string[];
  link?: string;
  isExternalLink?: boolean;
  buttonText: string;
};

const CpdCard = ({
  imagePathName,
  imageAlt,
  topic,
  subTopic,
  descriptions,
  link,
  isExternalLink = false,
  buttonText,
}: Props) => {
  const theme = useTheme();

  const handleClick = () => {
    if (isExternalLink) {
      window.open(link, '_blank');
      return;
    }
    Router.push(link || '');
  };

  return (
    <CpdCardBoxStyle>
      <Box
        sx={{
          display: 'content',
          overflow: 'hidden',
          alignContent: 'center',
          height: { xs: 'auto', md: '160px' },
          width: { xs: '100%', md: 'auto' },
        }}
      >
        <Image
          alt={imageAlt || ''}
          src={`${config.IMAGE_CDN_HOST}${imagePathName}`}
          srcSet={`${config.IMAGE_CDN_HOST}${imagePathName}`}
          errorImage={`${config.IMAGE_CDN_HOST}/assets/thumbnail-course-card.jpg`}
          className="image-card"
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: { md: 'start', lg: 'center' },
          justifyContent: 'space-between',
          width: '100%',
          flex: 1,
          flexDirection: { xs: 'column', lg: 'row' },
          gap: { xs: '24px', lg: 'unset' },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography color={theme.palette.primaryCPD.main} variant="h6">
            {topic}
          </Typography>
          <Typography color={theme.palette.primaryCPD.main} variant="h4" sx={{ mb: 2 }} className="sub-topic">
            {subTopic}
          </Typography>
          {descriptions?.map((description) => (
            <Typography color={theme.palette.textV2.secondary} variant="body1lanna" component={Box} key={description}>
              {description}
            </Typography>
          ))}
        </Box>

        {link && (
          <Button variant="outlined" color="primary" onClick={handleClick} sx={{ width: { lg: '200px', xs: '100%' } }}>
            {buttonText}
          </Button>
        )}
      </Box>
    </CpdCardBoxStyle>
  );
};

export default CpdCard;
